import axiosInstance from "../../../Axios/Axios";
import MeetingCard from "../MeetingCard/MeetingCard";


const getAllMeetingByIds = async ({ queryKey: info }: any) => {
  let ids = info[1];
  return await axiosInstance.get(
    `Meeting/GetAllMeetingsByTenantId?tenantId=${ids.tenantId}&periodId=${ids.priodId}&phoneNumber=${ids.userPhoneNumber}`
  );
};

const getAllMyMeetingByIds = async ({ queryKey: info }: any) => {
  let ids = info[1];
  return await axiosInstance.get(
    `Meeting/WebGetMyMeetingsByPersonId?tenantId=${ids.tenantId}&periodId=${ids.priodId}`
  );
};

const getAllTeamsByTenantId = async ({ queryKey }: any) => {
  let id = queryKey[1];
  return await axiosInstance.get(
    `Team/GetAllTeamByTenantId?tenantId=${id}&pageSize=50000&pageIndex=1`
  );
};
//
const getTeamDetailsById = async () => {
  return await axiosInstance.get(
    "Team/GetTeamDetailsById?id=fb7cc4ea-7162-4916-9aa8-834b14308e10"
  );
};

const getAllObjectiveByTeamId = async ({ queryKey }: any) => {
  let id = queryKey[1];
  return await axiosInstance.get(`OKR/GetAllObjectiveByTeamId?teamId=${id}`);
};

const getAllKeyResultByObjectiveId = async ({ queryKey }: any) => {
  let id: string = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllKeyResultByObjectiveId?objectiveId=${id}`
  );
};

const getAllTeamStatusByTenantId = async ({ queryKey }: any) => {
  let id: string = queryKey[1];
  return await axiosInstance.get(
    `Meeting/GetCheckinMeetingDetailsByMeetingId?meetingId=34eb3909-a296-448e-b0f5-dc068984c945`
  );
};

const getWebCheckinMeetingDetailsByMeetingId = async ({ queryKey }: any) => {
  let id: string = queryKey[1];
  return await axiosInstance.get(
    `Meeting/GetWebCheckinMeetingDetailsByMeetingId?meetingId=${id}`
  );
};

const getWebCheckinMyMeetingDetailsByMeetingId = async ({ queryKey }: any) => {
  let id: string = queryKey[1];
  return await axiosInstance.get(
    `Meeting/GetWebCheckinMyMeetingDetailsByMeetingId?meetingId=${id}`
  );
};

const getWebObjectiveDetailsCheckinMeetingByTeamId = async ({
  queryKey,
}: any) => {
  let id: string = queryKey[1];
  let priodId = queryKey[2];
  let meetingId = queryKey[3];
  return await axiosInstance.get(
    `Meeting/GetWebObjectiveDetailsCheckinMeetingByTeamId?teamId=${id}&periodId=${priodId}&meetingId=${meetingId}`
  );
};


const getWebObjectiveDetailsCheckinMyMeetingByTeamId = async ({
  queryKey,
}: any) => {
  let id: string = queryKey[1];
  let priodId = queryKey[2];
  let meetingId = queryKey[3];
  return await axiosInstance.get(
    `Meeting/GetWebObjectiveDetailsCheckinMyMeetingByTeamId?teamId=${id}&periodId=${priodId}&meetingId=${meetingId}`
  );
};


const getAlignmentMeetingDetailByTeamId = async ({
  queryKey,
}: any) => {
  let id: string = queryKey[1];
  let priodId = queryKey[2];
  let meetingId = queryKey[3];
  return await axiosInstance.get(
    `Meeting/GetObjectiveDetailsMeetingByTeamId?teamId=${id}&meetingId=${meetingId}`
  );
};


const getAllBAUsByTeamId = async ({
  queryKey,
}: any) => {
  let id: string = queryKey[1];
  let priodId = queryKey[2];
  let meetingId = queryKey[3];
  return await axiosInstance.get(
    `Index/GetAllBAUsByTeamId?teamId=${id}&periodId=${priodId}&meetingId=${meetingId}`
  );
};

const getAllTeamsForSelByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `Team/GetAllTeamByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`
  );
};

const getAllTeamsForSelByTenantIdNew = async (tenantId: string) => {
  return await axiosInstance.get(
    `Team/GetAllTeamByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`
  );
};

const getAllMeetingsTypeByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Meeting/GetAllMeetingsTypeByTenantId?tenantId=${tenantId}`
  );
};


const addMeeting = async (meetData: any) => {
  return await axiosInstance.post(`/Meeting/AddMeeting`, meetData);
};

const getMeetingKeyResultValueById = async ({ queryKey }: any) => {
  let ids: any = queryKey[1];
  return await axiosInstance.get(
    `/Meeting/GetMeetingKeyResultValueById?meetingId=${ids?.meetingId}&keyResultId=${ids?.krId}`
  );
};

const getMeetingDetailById = async ({ queryKey }: any) => {
  let meetingId: any = queryKey[1];
  return await axiosInstance.get(
    `/Meeting/GetMeetingDetailById?Id=${meetingId}`
  );
};

const editMeeting = async (meetingData: any) => {
  return await axiosInstance.post(`/Meeting/editMeeting`, meetingData);
};


const deleteMeeting = async (Ids: any) => {
  return await axiosInstance.post(`/Meeting/DeleteMeeting`, Ids);
};

export {
  getAllMeetingByIds,
  getAllTeamsByTenantId,
  getTeamDetailsById,
  getAllObjectiveByTeamId,
  getAllKeyResultByObjectiveId,
  getAllTeamStatusByTenantId,
  getWebCheckinMeetingDetailsByMeetingId,
  getWebObjectiveDetailsCheckinMeetingByTeamId,
  getAllBAUsByTeamId,
  getAllTeamsForSelByTenantId,
  getAllMeetingsTypeByTenantId,
  getWebObjectiveDetailsCheckinMyMeetingByTeamId,
  getAlignmentMeetingDetailByTeamId,
  addMeeting,
  getAllMyMeetingByIds,
  getWebCheckinMyMeetingDetailsByMeetingId,
  getMeetingKeyResultValueById,
  getMeetingDetailById,
  editMeeting,
  deleteMeeting,
  getAllTeamsForSelByTenantIdNew
};
